import { render, staticRenderFns } from "./MainModule.vue?vue&type=template&id=a4f886c2"
import script from "./MainModule.vue?vue&type=script&lang=js"
export * from "./MainModule.vue?vue&type=script&lang=js"
import style0 from "./MainModule.vue?vue&type=style&index=0&id=a4f886c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports